import { makeObservable } from 'mobx'
import type { MobxDocument } from '../firestore-mobx'
import {
  ObservableModelWithDecorators,
  emptyCollection,
  emptyModel,
} from '../firestore-mobx/model'
import type { FirebaseRepository } from './FirebaseRepository'
import {
  type FirestoreOrganizationCatalog,
  empty,
} from '../firestore/OrganizationCatalog/schema'

export class OrganizationCatalog extends ObservableModelWithDecorators<FirestoreOrganizationCatalog> {
  static empty(repository: FirebaseRepository) {
    return emptyModel(repository, this, empty)
  }

  static emptyCollection(repository: FirebaseRepository) {
    return emptyCollection(repository, this, empty)
  }

  constructor(
    repository: FirebaseRepository,
    doc: MobxDocument<FirestoreOrganizationCatalog>
  ) {
    super(repository, doc)

    makeObservable(this)
  }
}
